const importantStyles = [
    "content",
    "display",
    "lineHeight",
    "fontStretch",
    "fontStyle",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textAlign",
    "top",
    "left",
    "width",
    "height",
    "zIndex"
];

const notImportantStyles = [
    "alignContent",
    "alignItems",
    "backgroundAttachment",
    "backgroundColor",
    "backgroundImage",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundSize",    
    "borderStyle",
    "borderWidth",
    "borderColor",
    "borderLeftStyle",
    "borderLeftWidth",
    "borderLeftColor",
    "borderRightStyle",
    "borderRightWidth",
    "borderRightColor",
    "borderTopStyle",
    "borderTopWidth",
    "borderTopColor",
    "borderBottomStyle",
    "borderBottomWidth",
    "borderBottomColor",
    "borderSpacing",
    "boxSizing",
    "color",
    "direction",
    "flexDirection",
    "fill",
    "float",
    "gridTemplateColumn",
    "justifyContent",
    "justifyItems",
    "justifySelf",
    "letterSpacing",
    "lineBreak",
    "lineHeight",
    "listStyle",
    "listStyleImage",
    "listStylePosition",
    "listStyleType",
    "margin",
    "marginBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "opacity",
    "outline",
    "overflow",
    "padding",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "tableLayout",
    "textAlignLast",
    "textDecoration",
    "textDecorationColor",
    "textOverflow",
    "textTransform",
    "textIndent",
    "transform",
    "verticalAlign",
    "visibility",
    "webkitTextDecorationsInEffect",
    "whiteSpace",
    "wordBreak",
    "wordSpacing",
    "wordWrap"
];

const defaultStyles = {
    alignContent: "normal",
    alignItems: "normal",
    backgroundAttachment: "scroll",
    backgroundColor: "rgba(0, 0, 0, 0)",
    backgroundImage: "none",
    backgroundPosition: "0% 0%",    	
    backgroundRepeat: "repeat",
    backgroundSize: "auto",   
    borderStyle: "none",
    borderWidth: "0px",
    borderColor: "rgb(0, 0, 0)",
    borderLeftStyle: "none",
    borderLeftWidth: "0px",
    borderLeftColor: "rgb(0, 0, 0)",
    borderRightStyle: "none",
    borderRightWidth: "0px",
    borderRightColor: "rgb(0, 0, 0)",
    borderTopStyle: "none",
    borderTopWidth: "0px",
    borderTopColor: "rgb(0, 0, 0)",
    borderBottomStyle: "none",
    borderBottomWidth: "0px",
    borderBottomColor: "rgb(0, 0, 0)",
    borderSpacing: "0px 0px",
    boxSizing: "content-box",
    color: "rgb(0, 0, 0)",
    content: "none",
    direction: "ltr",
    fill: "rgb(0, 0, 0)",
    flexDirection: "",
    float: "none",
    gridTemplateColumns: "",
    fontStretch: "100%",
    fontStyle: "normal",
    fontWeight: "0",
    justifyContent: "flex-start",
    justifyItems: "normal",
    justifySelf: "auto",
    letterSpacing: "normal",
    lineBreak: "auto",
    lineHeight: "normal",
    listStyle: "disc outside none",
    listStyleImage: "none",
    listStylePosition: "outside",
    listStyleType: "none",
    margin: "0",
    marginBottom: "0px",
    marginLeft: "0px",
    marginRight: "0px",
    marginTop: "0px",
    opacity: "1",
    outline: "rgb(0, 0, 0) none 0px",
    overflow: "visible",
    padding: "0",
    paddingBottom: "0px",
    paddingLeft: "0px",
    paddingRight: "0px",
    paddingTop: "0px",
    tableLayout: "auto",
    textAlign: "start",
    textAlignLast: "auto",
    textDecoration: "none solid rgb(0, 0, 0)",
    textDecorationColor: "rgb(0, 0, 0)",
    textOverflow: "clip",
    textTransform: "none",
    textIndent:"0px",
    transform: "none",
    verticalAlign: "baseline",
    visibility: "visible",
    webkitTextDecorationsInEffect: "none",
    whiteSpace: "normal",
    wordBreak: "normal",
    wordSpacing: "0px",
    wordWrap: "break-word"
};

export const elementInnerSizeStyles = () => {
    return [
        "borderStyle",
        "borderWidth",
        "borderColor",
        "borderLeftStyle",
        "borderLeftWidth",
        "borderLeftColor",
        "borderRightStyle",
        "borderRightWidth",
        "borderRightColor",
        "borderTopStyle",
        "borderTopWidth",
        "borderTopColor",
        "borderBottomStyle",
        "borderBottomWidth",
        "borderBottomColor",
        "padding",
        "paddingTop",
        "paddingLeft",
        "paddingRight",
        "paddingBottom",
        "margin",
        "marginTop",
        "marginLeft",
        "marginRight",
        "marginBottom"
    ];
};

const isCorrectedStyle = (propertyKey, propertyValue, tagName) => {
    switch (propertyKey) {
        case `display`:
            return ![`flex`, `grid`, `inline-flex`].includes(propertyValue);
        case `gridTemplateColumns`:
            return false;
        case `flexDirection`:
            return false;
        case `lineHeight`:
            return false;
        default:
            return true;
    }
};

const convertStylePropertyToString = (propertyKey, propertyValue) => {
    return `${propertyKey.replace(/[^a-z]/g, (char) => `-${char.toLowerCase()}`)}:${String(propertyValue).replace(/"/g, ``)};`;
};

const getCorrectedStyle = (propertyKey, computedStyles) => {
    if (propertyKey === `lineHeight`) {
        return `${convertStylePropertyToString(propertyKey, computedStyles[propertyKey])}mso-line-height-rule:exactly;`;
    }
};

export const convertStyles = ({ computedStyles, includableStyles, excludableStyles }) => {
    const styleKeys = includableStyles && includableStyles.length ? includableStyles : Object.keys(computedStyles);
    const convertedStyles = styleKeys.map((propertyKey) => {
        if (computedStyles[propertyKey] !== undefined && (!excludableStyles || !excludableStyles.length || !excludableStyles.includes(propertyKey))) {
            if (isCorrectedStyle(propertyKey, computedStyles[propertyKey])) {
                return convertStylePropertyToString(propertyKey, computedStyles[propertyKey]);
            } else {
                return getCorrectedStyle(propertyKey, computedStyles);
            }
        }
    });
    return convertedStyles.join(``);
};

export const getOuterContainerSizes = (element) => {
    const computedStyles = window.getComputedStyle(element, null);
    const width = element.offsetWidth + parseFloat(computedStyles.marginLeft) + parseFloat(computedStyles.marginRight);
    const height = element.offsetHeight + parseFloat(computedStyles.marginTop) + parseFloat(computedStyles.marginBottom);
    return {
        width,
        height
    };
};

export const getStyle = (element, pseudo = null) => {
    const styles = {};
    if (element.nodeType === Node.ELEMENT_NODE) {
        const computedStyles = window.getComputedStyle(element, pseudo);
        for (const styleKey of importantStyles) {
            styles[styleKey] = computedStyles[styleKey];
        }
        for (const styleKey of notImportantStyles) {
            const value = computedStyles[styleKey];
            if (value !== "" && value != defaultStyles[styleKey]) {
                if (styleKey === 'outline' && value.includes('none')) continue;
                styles[styleKey] = value;
            }
        }
    }
    return styles;
}; 